import * as React from 'react';
import { useEffect } from 'react';
import { IconButton } from '@workboard/wobo-ui';
import { Menu, MenuItem, ListItemIcon, Divider } from '@mui/material';
import { Modal, ModalHeader, ModalContent, ModalWrapper } from '@workboard/wobo-ui';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import UnsubscribeOutlineIcon from '@mui/icons-material/UnsubscribeOutlined';
import styled from 'styled-components';
import { deleteListById, unsubscribeFromListById } from './listHelpers/lists.api';
import './lists.css';
import { useTranslation } from 'react-i18next';

const StyledDeleteModal = styled(Modal)`
  ${ModalWrapper} {
    width: 465px;
  }
  ${ModalHeader} {
    padding: 10px 20px !important;
    h1 {
      font-size: 16px !important;
    }
  }
  ${ModalContent} {
    padding: 20px !important;
    p {
       line-height: 1.5;
       margin: 0;
    }
`;
// 5 = calibre list
const NOT_EDITABLE_LIST_TYPES = [2, 5];

export const MenuComponent = ({ list, setDeleted, setUpdateData, setUnsubscribed, listOwner, resourceType }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [confirmPopup, setConfirmPopup] = React.useState(false);
  const [actionType, setActionType] = React.useState(null);
  const [isDisabled, setIsDisabled] = React.useState(false);
  const isOwner = listOwner == window.uData.user_id;

  const handleEditList = () => {
    setAnchorEl(null);
    window?.initListBuilderComponent('list-dialog', setUpdateData, null, +list.id, resourceType);
  };

  const handleKabobClose = () => {
    setAnchorEl(null);
    setConfirmPopup(false);
  };

  const handleKabobClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDeleteIconClick = () => {
    setConfirmPopup(true);
    setActionType('delete');
  };

  const handleUnsubscribeIconClick = () => {
    setConfirmPopup(true);
    setActionType('unsubscribe');
  };

  const handleDeletePopupClose = () => {
    handleKabobClose();
  };

  const handleDeletePopupConfirm = async () => {
    if (actionType === 'unsubscribe') {
      await unsubscribeFromListById(list.id, setUnsubscribed);
    } else {
      await deleteListById(list.id, setDeleted);
    }
    handleDeletePopupClose();
  };

  useEffect(() => {
    const isDisabled =  list?.isDynamic && NOT_EDITABLE_LIST_TYPES.includes(+list?.type?.id);
    setIsDisabled(isDisabled);
  }, []);

  return (
    <div>
      <IconButton
        className="list-kabob-button"
        onClick={handleKabobClick}
        isDisabled={isDisabled}
      >
        <MoreVertIcon className="list-kabob-icon" />
      </IconButton>
      <Menu
        className="list-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleKabobClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {isOwner ? (
          <>
            <MenuItem className="list-menu-item" onClick={handleEditList}>
              <ListItemIcon className="list-menu-item-icon">
                <EditOutlinedIcon />
              </ListItemIcon>
              {t('Edit')}
            </MenuItem>
            <Divider className="list-divider" />
            <MenuItem className="list-menu-item" onClick={handleDeleteIconClick}>
              <ListItemIcon className="list-menu-item-icon">
                <DeleteOutlineIcon />
              </ListItemIcon>
              {t('Delete')}
            </MenuItem>
          </>
        ) : (
          <MenuItem className="list-menu-item" onClick={handleUnsubscribeIconClick}>
            <ListItemIcon className="list-menu-item-icon">
              <UnsubscribeOutlineIcon />
            </ListItemIcon>
            {t('Unsubscribe')}
          </MenuItem>
        )}
        <StyledDeleteModal
          className="list-delete-modal"
          dismissLabel={'Cancel'}
          submitLabel={actionType === 'unsubscribe' ? t('Unsubscribe') : t('Delete')}
          isDanger
          isOpen={confirmPopup}
          onDismiss={handleDeletePopupClose}
          onSubmit={handleDeletePopupConfirm}
          title={actionType === 'unsubscribe' ? 'Unsubscribe  From List' : 'Delete List'}
        >
          <p>
            {actionType === 'unsubscribe' ? (
              <>
                {t('Are you sure you want to unsubscribe from list')} <strong>{list.name}</strong>? <br />
                {t('This cannot be undone')}.
              </>
            ) : (
              <>
                {t('Are you sure you want to delete list')} <strong>{list.name}</strong>? <br />
                {t('This cannot be undone')}.
              </>
            )}
          </p>
        </StyledDeleteModal>
      </Menu>
    </div>
  );
};
